<template>
    <v-dialog v-model="dialog" width="600" persistent transition="dialog-bottom-transition" @keydown.esc="close">
        <v-card class="scouting-add-edit-dialog-card">
            <v-toolbar dark color="primary">
                <v-spacer></v-spacer>
                <v-toolbar-title>Other Pest</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                </v-toolbar-items>
            </v-toolbar>
            <v-form ref="form" v-model="editValid">
                <v-container>
                    <v-layout row wrap>
                        <v-flex>                        
                            <v-text-field clearable label="Name" v-model="name" :rules="[rules.required]" />
                        </v-flex>
                        <v-layout align-center fill-height>
                            <v-flex shrink>
                                <v-btn color="accent" icon @click="observationDecrease" small><v-icon>chevron_left</v-icon></v-btn>
                            </v-flex>                                    
                            <v-flex shrink>
                                <v-text-field                                            
                                    class="pl-1 pr-1"                                            
                                    :value="observation"
                                    readonly
                                    label="Score"
                                    :rules="[rules.required]"
                                    clearable>
                                </v-text-field>
                            </v-flex>                                    
                            <v-flex shrink>
                                <v-btn color="accent" icon  @click="observationIncrease" small><v-icon>chevron_right</v-icon></v-btn>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                </v-container>                
                <v-layout wrap class="dialog-action-buttons">
                    <v-flex xs12 sm6>
                        <v-btn block color="error" @click="close">Cancel</v-btn>
                    </v-flex>
                    <v-flex xs12 sm6 >
                        <v-btn block color="success" :disabled="!editValid" @click="save">Save</v-btn>
                    </v-flex>
                </v-layout>   
            </v-form>
        </v-card>
    </v-dialog>
</template>
<script>
import validationRules from "@/helpers/validationrules";

export default {
    data() {
        return {
            editValid: true,
            name: null,
            observation: 0,
            rules: validationRules.rules
        }
    },
    props: [
        "dialog",
        "scoutingScoreScale"       
    ],
    components: {
    },
    methods: {
        observationDecrease() {
            let newVal = this.scoutingScoreScale.Maximum;

            if (this.observation) {
                let observationNumber = parseFloat(this.observation);

                newVal = Math.round((observationNumber - this.scoutingScoreScale.Interval) * 100) / 100;
            }

            this.observation = Math.max(newVal, this.scoutingScoreScale.Minimum);
        },
        observationIncrease() {
            let newVal = this.scoutingScoreScale.Minimum;

            if (this.observation) {
                let observationNumber = parseFloat(this.observation);

                newVal =  Math.round((observationNumber + this.scoutingScoreScale.Interval) * 100) / 100;
            }

            this.observation = Math.min(newVal, this.scoutingScoreScale.Maximum);
        },
        close() {
           this.$emit("close");
        },
        save() {
            this.$emit('save', { observation: this.observation, name: this.name });
        }
    },
    created() {        
    }
}
</script>
<style>
</style>
